module.exports = __webpack_public_path__ + "static/media/Атанов А.В. (КФА).c65dabb6.pdf";